export default __webpack_public_path__ + "static/Artist-c81a1431815ac0aebb0f18652f4e0aba.png";